import React from 'react'
import "./DeletePopup.css";
import { motion } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import { removeDeleteLodge, removeLodge, selectDeleteLodge, startDeleting } from '../../features/slices/lodgeSlice';
import axios from 'axios';
import { DELETE_URL } from '../../api/customEnpoints';
import { toast } from 'react-toastify';
import { selectUser } from '../../features/slices/userSlice';
import Spinner from '../spinner/Spinner';

const DeletePopup = ({id, name}) => {
    const getUser = useSelector(selectUser) 
    const deleteObj = useSelector(selectDeleteLodge)
    const dispatch = useDispatch()

    const handleCancelDelete = () => {
        dispatch(removeDeleteLodge())
    }

    const handleDeleteAction = async() => {
        
        try {
            dispatch(startDeleting())
            const response = await axios.delete(`${DELETE_URL}/${id}`, {
                headers: { "x-auth-token": getUser?.token },
                withCredentials: true,
            });
                dispatch(removeLodge(id));
                dispatch(removeDeleteLodge());
                toast.success(response?.data?.message);
                window.location.reload();
            } catch (error) {
                toast.error(error?.response?.data?.msg);
                dispatch(removeDeleteLodge());
            }
    }

  return (
    <div className="delete-popup">
        <div className="delete-popup-box">
            { deleteObj?.loading && <Spinner /> }
            <h4>Are You Sure You Want To Delete {name} Lodge?</h4>
            <p>This action cannot be undone!</p>
            <div className="delete-action-btns">
                <motion.button onClick={handleDeleteAction} whileTap={{ scale: 0.8 }} className='btn-yes'>Yes</motion.button>
                <motion.button onClick={handleCancelDelete} whileTap={{ scale: 0.8 }} className='btn-cancel'>Cancel</motion.button>
            </div>
        </div>
    </div>
  )
}

export default DeletePopup